import React, { useRef, useEffect } from 'react';
import { View, ScrollView, StyleSheet, Platform, Dimensions } from 'react-native';
import { globalStyles } from '../../styles/globalStyles';

// Detectar si estamos en móvil web
const { width: viewportWidth } = Dimensions.get('window');
const isMobileWeb = Platform.OS === 'web' && viewportWidth < 768;

/**
 * Componente contenedor para carruseles que previene el scroll horizontal de la página
 * y asegura que el carrusel funcione correctamente en móvil web
 */
const CarouselContainer = ({ 
  children, 
  snapToInterval, 
  pagingEnabled = isMobileWeb,
  onMomentumScrollEnd,
  onScrollBeginDrag,
  onScrollEndDrag,
  contentContainerStyle,
  style,
  ...props 
}) => {
  const scrollViewRef = useRef(null);
  
  // Aplicar estilos específicos al carrusel en móvil web
  useEffect(() => {
    if (Platform.OS === 'web' && scrollViewRef.current) {
      const scrollViewNode = scrollViewRef.current.getScrollableNode ? 
        scrollViewRef.current.getScrollableNode() : 
        scrollViewRef.current;
      
      if (scrollViewNode && isMobileWeb) {
        // Aplicar clases CSS para móvil web
        scrollViewNode.classList.add('carousel-container');
        
        // Aplicar estilos inline para mayor compatibilidad
        // IMPORTANTE: usar 'auto' para permitir scroll vertical de la página
        // mientras el carrusel maneja el scroll horizontal internamente
        scrollViewNode.style.touchAction = 'auto';
        scrollViewNode.style.WebkitOverflowScrolling = 'touch';
        scrollViewNode.style.overscrollBehaviorX = 'contain';
        scrollViewNode.style.scrollSnapType = 'x mandatory';
        scrollViewNode.style.msOverflowStyle = 'none';
        scrollViewNode.style.scrollbarWidth = 'none';
        scrollViewNode.style.overflowX = 'scroll';
        scrollViewNode.style.overflowY = 'hidden';
        
        // No prevenir el scroll de la página - permitir que el usuario
        // pueda hacer scroll vertical normalmente
        return () => {};
      }
    }
  }, [isMobileWeb]);
  
  // Ya no prevenimos el scroll - permitimos scroll vertical de la página
  
  return (
    <View style={[styles.container, isMobileWeb && styles.mobileWebContainer]}>
      <ScrollView
        ref={scrollViewRef}
        horizontal
        showsHorizontalScrollIndicator={false}
        decelerationRate="fast"
        snapToInterval={snapToInterval}
        snapToAlignment="center"
        pagingEnabled={pagingEnabled}
        onMomentumScrollEnd={onMomentumScrollEnd}
        onScrollBeginDrag={onScrollBeginDrag}
        onScrollEndDrag={onScrollEndDrag}
        contentContainerStyle={contentContainerStyle}
        style={[
          globalStyles.carouselScrollView,
          isMobileWeb && styles.mobileWebScrollView,
          style
        ]}
        directionalLockEnabled={true}
        {...props}
      >
        {children}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  mobileWebContainer: {
    overflow: 'hidden',
  },
  mobileWebScrollView: {
    width: viewportWidth,
    maxWidth: '100%',
    scrollBehavior: 'smooth',
  }
});

export default CarouselContainer;
